interface Config {
  apiGateway: {
    URL: string;
  };
  availableFunctions: string[];
}

/**
 * Variables de entorno
 *
 * Las variables de entorno son obtenidas del archivo public/env.js el cual es cargado en el head del root HTML public/index.html
 * Aca se las procesa para obtener un valor por defecto
 */
function getAppConfig(): Config {
  const env = (window as any).env;

  return {
    apiGateway: {
      // Se establece el string 'not_valid_api' como fallback para detectar que el entorno no tiene disponible la variable API_URL
      URL: env?.API_URL || 'not_valid_api',
    },
    availableFunctions: [...(env?.availableFunctions || [])],
  };
}

export const config: Config = getAppConfig();
